import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { ContainerCondition, ContainerSizeType, CreatedBy, IOneWayQuoteItemModel, IOneWayQuoteModel, LocationModel, UploadedDocument, InsuranceModel, QuoteChargeMaster, QuoteChargeMasterError } from "../base-quote.model";

export class OneWayQuoteItemError {
    id: string[];
    requirement: string[];
    quantity: string[];
    min_free_days: string[];
    max_free_days: string[];
    pickup_charge_currency: string[];
    pickup_charge: string[];
    min_per_diem_currency: string[];
    min_per_diem: string[];
    max_per_diem_currency: string[];
    max_per_diem: string[];
    dpp_charge_currency: string[];
    dpp_charge: string[];
    storage_charge_currency: string[];
    storage_charge: string[];
    dropoff_charge_currency: string[];
    dropoff_charge: string[];
    cancellation_charge_currency: string[];
    cancellation_charge: string[];
    min_late_charge_currency: string[];
    min_late_charge: string[];
    max_late_charge_currency: string[];
    max_late_charge: string[];
    created_by: string[];
    quote: string[];
    container_size_type: string[];
    container_condition: string[];
    pol_list: string[];
    pod_list: string[];

    drv_new_build_price: string[];
    drv_new_build_price_currency: string[];
    drv_max_depreciation_price: string[];
    drv_max_depreciation_price_currency: string[];
    drv_max_depreciation_percent: string[];
    drv_depreciation_per_year: string[];
    drv_max_depreciation_unit: string[];

    constructor() {
        this.id = [];
        this.requirement = [];
        this.quantity = [];
        this.min_free_days = [];
        this.max_free_days = [];
        this.pickup_charge_currency = [];
        this.pickup_charge = [];
        this.min_per_diem_currency = [];
        this.min_per_diem = [];
        this.max_per_diem_currency = [];
        this.max_per_diem = [];
        this.dpp_charge_currency = [];
        this.dpp_charge = [];
        this.storage_charge_currency = [];
        this.storage_charge = [];
        this.dropoff_charge_currency = [];
        this.dropoff_charge = [];
        this.cancellation_charge_currency = [];
        this.cancellation_charge = [];
        this.min_late_charge_currency = [];
        this.min_late_charge = [];
        this.max_late_charge_currency = [];
        this.max_late_charge = [];
        this.created_by = [];
        this.quote = [];
        this.container_size_type = [];
        this.container_condition = [];
        this.pol_list = [];
        this.pod_list = [];

        this.drv_new_build_price = [];
        this.drv_new_build_price_currency = [];
        this.drv_max_depreciation_price = [];
        this.drv_max_depreciation_price_currency = [];
        this.drv_max_depreciation_percent = [];
        this.drv_depreciation_per_year = [];
        this.drv_max_depreciation_unit = [];
    }
}

export class OneWayQuoteError {
    id: string[];
    request: string[];
    quote_items: OneWayQuoteItemError[];
    quote_valid_till: string[];
    document: string[];
    uploaded_documents: string[];
    remarks: string[];
    quote_number: string[];
    created_by: string[];
    terms_and_condition_text: string[];
    terms_and_condition_fk: string[];
    payee: string[];
    insurance: string[];
    insurance_premium: string[];
    insurance_premium_currency: string[];
    ad_hoc_charges: QuoteChargeMasterError[];

    constructor() {
        this.id = [];
        this.request = [];
        this.quote_items = [new OneWayQuoteItemError()];
        this.quote_valid_till = [];
        this.document = [];
        this.uploaded_documents = [];
        this.remarks = [];
        this.quote_number = [];
        this.created_by = [];
        this.terms_and_condition_text = [];
        this.terms_and_condition_fk = [];
        this.payee = [];
        this.insurance = [];
        this.insurance_premium = [];
        this.insurance_premium_currency = [];
        this.ad_hoc_charges = [];
    }

    patchErrors(errors) {
        this.quote_items = errors != null && errors.quote_items?.length ? errors.quote_items : [new OneWayQuoteItemError()];
        this.quote_valid_till = errors != null && errors.quote_valid_till ? errors.quote_valid_till : [];
        this.uploaded_documents = errors != null && errors.uploaded_documents ? errors.uploaded_documents : [];
        this.ad_hoc_charges = errors != null && errors.ad_hoc_charges ? errors.ad_hoc_charges : [new QuoteChargeMasterError()];
        this.remarks = errors != null && errors.remarks ? errors.remarks : [];
        this.payee = errors != null && errors.payee ? errors.payee : [];
        this.insurance = errors != null && errors.insurance ? errors.insurance : [];
        this.insurance_premium = errors != null && errors.insurance_premium ? errors.insurance_premium : [];
        this.insurance_premium_currency = errors != null && errors.insurance_premium_currency ? errors.insurance_premium_currency : [];
        this.terms_and_condition_text = errors != null && errors.terms_and_condition_text ? errors.terms_and_condition_text : [];
        this.terms_and_condition_fk = errors != null && errors.terms_and_condition_fk ? errors.terms_and_condition_fk : [];
    }
}

export class OneWayQuoteItemModel implements IOneWayQuoteItemModel {
    id: string;
    requirement: string;
    quantity: number;
    min_free_days: number;
    max_free_days: number;
    pickup_charge_currency: string;
    pickup_charge: number;
    min_per_diem_currency: string;
    min_per_diem: number;
    max_per_diem_currency: string;
    max_per_diem: number;
    dpp_charge_currency: string;
    dpp_charge: number;
    storage_charge_currency: string;
    storage_charge: number;
    dropoff_charge_currency: string;
    dropoff_charge: number;
    cancellation_charge_currency: string;
    cancellation_charge: number;
    min_late_charge_currency: string;
    min_late_charge: number;
    max_late_charge_currency: string;
    max_late_charge: number;
    created_by: CreatedBy;
    quote: string;
    container_size_type: ContainerSizeType;
    container_condition: ContainerCondition;
    pol_list: LocationModel[];
    pod_list: LocationModel[];

    drv_new_build_price: number;
    drv_new_build_price_currency: string;
    drv_max_depreciation_price: number;
    drv_max_depreciation_price_currency: string;
    drv_max_depreciation_percent: number;
    drv_depreciation_per_year: number;
    drv_max_depreciation_unit: string;
    ad_hoc_charges?: QuoteChargeMaster[]

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.requirement = data != null ? data.requirement : null;
        this.quantity = data != null ? data.quantity : null;
        this.min_free_days = data != null ? data.min_free_days : null;
        this.max_free_days = data != null ? data.max_free_days : null;
        this.pickup_charge_currency = data != null ? data.pickup_charge_currency : 'USD';
        this.pickup_charge = data != null ? data.pickup_charge : null;
        this.min_per_diem_currency = data != null ? data.min_per_diem_currency : 'USD';
        this.min_per_diem = data != null ? data.min_per_diem : null;
        this.max_per_diem_currency = data != null ? data.max_per_diem_currency : 'USD';
        this.max_per_diem = data != null ? data.max_per_diem : null;
        this.dpp_charge_currency = data != null ? data.dpp_charge_currency : 'USD';
        this.dpp_charge = data != null ? data.dpp_charge : null;
        this.storage_charge_currency = data != null ? data.storage_charge_currency : 'USD';
        this.storage_charge = data != null ? data.storage_charge : null;
        this.dropoff_charge_currency = data != null ? data.dropoff_charge_currency : 'USD';
        this.dropoff_charge = data != null ? data.dropoff_charge : null;
        this.cancellation_charge_currency = data != null ? data.cancellation_charge_currency : 'USD';
        this.cancellation_charge = data != null ? data.cancellation_charge : null;
        this.min_late_charge_currency = data != null ? data.min_late_charge_currency : 'USD';
        this.min_late_charge = data != null ? data.min_late_charge : null;
        this.max_late_charge_currency = data != null ? data.max_late_charge_currency : 'USD';
        this.max_late_charge = data != null ? data.max_late_charge : null;
        this.created_by = data != null ? data.created_by : null;
        this.quote = data != null ? data.quote : null;
        this.container_size_type = data != null ? data.container_size_type : new ContainerSizeType();
        this.container_condition = data != null ? data.container_condition : new ContainerCondition();
        this.pol_list = data != null ? data.pol_list : [];
        this.pod_list = data != null ? data.pod_list : [];

        this.drv_new_build_price = data != null ? data.drv_new_build_price : null;
        this.drv_new_build_price_currency = data != null ? data.drv_new_build_price_currency : 'USD';
        this.drv_max_depreciation_price = data != null ? data.drv_max_depreciation_price : null;
        this.drv_max_depreciation_price_currency = data != null ? data.drv_max_depreciation_price_currency : 'USD';
        this.drv_max_depreciation_percent = data != null ? data.drv_max_depreciation_percent : null;
        this.drv_depreciation_per_year = data != null ? data.drv_depreciation_per_year : null;
        this.drv_max_depreciation_unit = data != null ? data.drv_max_depreciation_unit : 'price';
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];
    }

    saveFirstPayload(data) {
        this.requirement = data.id;
        this.quantity = data.quantity;
        this.container_size_type = data.container_size_type;
        this.container_condition = data.condition;
    }

    setQuoteItemFromInternalRequestRequirement(int_requirement, int_request,default_currency,oneWayQuoteObj) {
        this.requirement = int_requirement.id;
        this.quantity = int_requirement.quantity;
        this.container_size_type = int_requirement.container_size_type;
        this.container_condition = int_requirement.condition;
        this.pol_list = int_request != null ? int_request.pols : [];
        this.pod_list = int_request != null ? int_request.pods : [];
        this.pickup_charge_currency = default_currency;
        this.min_per_diem_currency = default_currency;
        this.max_per_diem_currency = default_currency;
        this.dropoff_charge_currency = default_currency;
        this.cancellation_charge_currency = default_currency;
        this.drv_new_build_price_currency = default_currency;
        this.drv_max_depreciation_price_currency = default_currency;
        this.dpp_charge_currency = default_currency;
        this.storage_charge_currency = default_currency;
        this.max_late_charge_currency = default_currency;
        this.min_late_charge_currency = default_currency;
        oneWayQuoteObj.insurance_premium_currency = default_currency;
    }

    getOneWayQuoteItemSavePayload() {
        let chargePayload = [];
        if (this.ad_hoc_charges.length != 0) {
            this.ad_hoc_charges.map(charge => {
                chargePayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                })
            })
        }

        return {
            requirement: this.requirement,
            quantity: this.quantity,
            min_free_days: this.min_free_days,
            max_free_days: this.max_free_days,
            pickup_charge_currency: this.pickup_charge_currency,
            pickup_charge: this.pickup_charge,
            min_per_diem_currency: this.min_per_diem_currency,
            min_per_diem: this.min_per_diem,
            max_per_diem_currency: this.max_per_diem_currency,
            max_per_diem: this.max_per_diem,
            dpp_charge_currency: this.dpp_charge_currency,
            dpp_charge: this.dpp_charge,
            storage_charge_currency: this.storage_charge_currency,
            storage_charge: this.storage_charge,
            dropoff_charge_currency: this.dropoff_charge_currency,
            dropoff_charge: this.dropoff_charge,
            cancellation_charge_currency: this.cancellation_charge_currency,
            cancellation_charge: this.cancellation_charge,
            min_late_charge_currency: this.min_late_charge_currency,
            min_late_charge: this.min_late_charge,
            max_late_charge_currency: this.max_late_charge_currency,
            max_late_charge: this.max_late_charge,
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            container_condition: typeof this.container_condition == 'object' && this.container_condition != null ? this.container_condition.id : this.container_condition,
            pol_list: this.pol_list.map((item) => item.id),
            pod_list: this.pod_list.map((item) => item.id),

            drv_new_build_price: this.drv_new_build_price,
            drv_new_build_price_currency: this.drv_new_build_price_currency,
            drv_max_depreciation_price: this.drv_max_depreciation_unit == 'price' ? this.drv_max_depreciation_price : null,
            drv_max_depreciation_price_currency: this.drv_max_depreciation_unit == 'price' ? this.drv_max_depreciation_price_currency : null,
            drv_max_depreciation_percent: this.drv_max_depreciation_unit == 'percent' ? this.drv_max_depreciation_percent : null,
            drv_depreciation_per_year: this.drv_depreciation_per_year,
            drv_max_depreciation_unit: this.drv_max_depreciation_unit,
            ad_hoc_charges: chargePayload
        }
    }
}

export class OneWayQuoteModel implements IOneWayQuoteModel {
    id: string;
    request: string;
    quote_items: OneWayQuoteItemModel[];
    quote_valid_till: Date;
    document: UploadedDocument;
    uploaded_documents: UploadedDocument[];
    remarks: string;
    quote_number: string;
    created_by: CreatedBy;
    payee: string;
    insurance: InsuranceModel;
    insurance_premium: number;
    insurance_premium_currency: string;
    terms_and_condition_text: string;
    terms_and_condition_fk: TermsAndConditionsModel;
    ad_hoc_charges: QuoteChargeMaster[];

    error: OneWayQuoteError;

    constructor(data = null) {
        this.id = data != null ? data.id : null;
        this.request = data != null ? data.request : null;
        this.quote_items = [];
        let quote_valid_till = new Date();
        quote_valid_till.setDate(quote_valid_till.getDate() + 14);
        this.quote_valid_till = data != null ? data.quote_valid_till : quote_valid_till;
        this.document = data != null ? data.document : null;
        this.uploaded_documents = data != null ? data.uploaded_documents : [];
        this.remarks = data != null ? data.remarks : null;
        this.quote_number = data != null ? data.quote_number : null;
        this.created_by = data != null ? data.created_by : null;
        this.terms_and_condition_text = data != null ? data.terms_and_condition_text : null;
        this.terms_and_condition_fk = data != null ? data.terms_and_condition_fk : null;
        this.payee = data != null ? data.payee : null;
        this.insurance = data != null ? data.insurance : null;
        this.insurance_premium = data != null ? data.insurance_premium : null;
        this.insurance_premium_currency = data != null ? data.insurance_premium_currency : 'USD';
        this.ad_hoc_charges = data != null ? data.ad_hoc_charges : [];

        this.error = new OneWayQuoteError();

        if (data != null && data.quote_items.length != 0) {
            for (let i = 0; i < data.quote_items.length; i++) {
                this.quote_items[i] = new OneWayQuoteItemModel(data.quote_items[i]);
                this.error.quote_items[i] = new OneWayQuoteItemError();
            }
        } else {
            this.quote_items = [new OneWayQuoteItemModel()];
        }
    }

    setDataFromInternalRequest(int_request,default_currency,oneWayQuoteObj) {
        this.request = int_request != null ? int_request.id : null;
        this.quote_items = [];
        this.payee = int_request != null ? int_request.transaction_type == 'use' ? 'customer' : 'supplier' : null;

        this.error = new OneWayQuoteError();

        if (int_request != null && int_request.requirement.length != 0) {
            for (let i = 0; i < int_request.requirement.length; i++) {
                this.quote_items[i] = new OneWayQuoteItemModel();
                this.quote_items[i].setQuoteItemFromInternalRequestRequirement(int_request.requirement[i], int_request,default_currency,oneWayQuoteObj)
                this.error.quote_items[i] = new OneWayQuoteItemError();
            }
        } else {
            this.quote_items = [new OneWayQuoteItemModel()];
        }
    }

    getOneWayQuoteSavePayload() {
        let chargePayload = [];
        if (this.ad_hoc_charges.length != 0) {
            this.ad_hoc_charges.map(charge => {
                chargePayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                })
            })
        }

        return {
            id: this.id,
            request: this.request,
            quote_items: this.quote_items.map(item => item.getOneWayQuoteItemSavePayload()),
            quote_valid_till: this.quote_valid_till,
            uploaded_documents: this.uploaded_documents.map((item) => item.id),
            remarks: this.remarks,
            terms_and_condition_text: this.terms_and_condition_text,
            terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
            payee: this.payee,
            insurance: typeof this.insurance == 'object' && this.insurance != null ? this.insurance.id : this.insurance,
            insurance_premium: this.insurance_premium,
            insurance_premium_currency: this.insurance_premium_currency,
            ad_hoc_charges: chargePayload
        }
    }
}